import React, { useContext, useEffect, useState } from 'react';
import { css } from '@emotion/css';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import SelectFulfillmentMethod from './SelectFulfillmentMethod';
import { useApp } from '../../context/app-context';
import UserMessage from '../../common/UserMessage/UserMessage';
import LoadingComponent from '../../common/LoadingComponent/LoadingComponent';
import { cond, filter, find, get, invoke, map } from 'lodash';
import appLabels from '../../utils/appLabels';
import { PreferencesContext, PreferencesContextType } from './PreferencesContext';
import { PaymentWallet } from 'ospg-payment-wallet';
import { DeliveryInstructionType, DriverTipType, paymentConfig } from '../../utils/constants';
import SlotPreferences from '../SlotPreferences/SlotPreferences';
import Modal from '../../common/Modal/Modal';
import { SessionContext, SessionContextType } from '../LandingPage/SessioncContext';
import updateCardStatus from '../../service/request-card-status-update';
import { Spinner } from '../../common/Spinner/Spinner';
import { TipOptions, CustomTip } from '../Order/DriverTipComponent';
import formatString, { formatPrice } from '../../utils/formatString';
import { DELIVERY_NOTES_CHAR_COUNT, isMobile, isMobileScreen } from '../../utils/utils';
import { useForm } from 'react-hook-form';
import updateDeliveryInstructionsService from '../../service/update-delivery-instructions-service';
import updateDriverTipService from '../../service/update-driver-tip-service';
import ErrorIcon from '../../common/Icons/ErrorIcon';

const mainContainerStyle = css`
  display: flex;
  flex-direction: column;
  padding-top: 1.5rem;
`;
const paymentErrorMessageContainereStyle = css`
  display: flex;
  align-items: center;
  border-radius: 8px;
  border: 1px solid #fbb5b5;
  background: #faf9f8;
  padding: 12px 16px;
  margin-bottom: 24px;
  gap: 10px;
`;

const paymentErrorMessagTextStyle = css`
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 1.125rem;
`;

const addPaymentTextContainerStyle = css`
  display: flex;
`;
const addPaymentTextStyle = css`
  font-size: 12px;
  font-weight: 400;
  color: #b00000;
  padding: 2px 0 0 4px;
`;

const preferencesContainerStyle = css`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto;
  width: 100%;
  row-gap: 1rem;

  @media (max-width: 641px) {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
`;

const colStyle = css`
  flex: 1;
`;

const sectionStyle = css`
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 0 1rem 1rem 1rem;
`;

const sectionMobileStyle = css`
  @media (max-width: 641px) {
    padding-bottom: 0;
  }
`;

const sectionTitleStyle = css`
  font-weight: 600 !important;
  color: #2a2928;
  margin: 0 0 0.5rem 0;

  display: flex;
  align-items: center;
`;

const titleRowStyle = css`
  display: flex;

  & > :first-child {
    flex: 1;
  }
`;

const deliveryInstructionStyle = css`
  display: flex;
  align-items: center;
`;

const defaultDeliveryInstructiontStyle = css`
  font-size: 1rem;
  font-weight: 400;
  color: #6e6e6d;
`;

const deliveryInstructionMessage = css`
  @media (max-width: 641px) {
    margin-bottom: 0;
  }
`;

const deliveryInstructionActiveStyle = css`
  font-size: 0.75rem;
`;
const deliveryInstructionTypeStyle = css`
  margin-bottom: 0;
`;
const textStyle = css`
  margin: 0;
`;

const fullAddressOneSpace = css`
  margin-top: 0.5rem;
  margin-bottom: 0;

  @media (max-width: 641px) {
    margin-top: 0;
  }
`;

const editButtonContainerStyle = css`
  color: #7b1a27;
`;

const EditButton = styled.button`
  border: 0;
  background: 0;
  padding-right: 2.5rem;

  @media (max-width: 641px) {
    padding: 0;
  }
`;

const deliveryTypeStyle = css`
  display: flex;
`;

const driverTipStyle = css`
  display: flex;
  align-items: center;
  svg {
    margin-top: 2px;
  }
`;
const editDriverTipStyle = css`
  display: flex;
  align-items: center;
  margin-top: 1rem;
  svg.blueInfoIcon {
    margin-bottom: 0;
    margin-right: 4px;
  }
  p {
    color: #2d5a7a;
    font-size: 12px !important;
    margin-bottom: 0;
  }
`;
const IconStyle = css`
  margin-right: 0.5rem;
`;

const tenderIcon = css`
  width: 40px;
  margin-right: 1rem;
`;

const errorContainer = css`
  margin-top: 1rem;
`;

const paymentFailureStyle = css`
  color: #dd1e25;
  margin-left: 0.5rem;
`;

const driverTipSaveButton = css`
  @media (max-width: 641px) {
    width: 85% !important;
  }
`;

const driverTipOptionsInfo = css`
  @media (max-width: 641px) {
    width: auto !important;
  }
`;

const driverTipOptionsContainer = css`
  width: 85%;
  @media (max-width: 641px) {
    display: flex;
    justify-content: center;
    width: 100%;
  }
`;

const driverTipOptionsStyle = css`
  display: grid;
  grid-template-rows: repeat(2, 1fr);
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;

  @media (max-width: 641px) {
    width: 93%;
  }
`;

const customTipStyle = css`
  grid-column: 2 / 4;
  width: auto;
  display: flex;
  padding: 0;
`;

const driverTipInfoStyle = css`
  font-weight: 400;
  font-size: 1rem;
  line-height: 23.2px;
  color: #6e6e6d;
`;

const deliveryInstructionModal = css`
  display: flex;
  flex-direction: column;
  margin: 1.5rem;
  width: auto;
  height: auto;
  @media (max-width: 641px) {
    width: auto;
    height: auto;
    margin: 0 0.625rem 0.938rem;
  }
`;

const deliveryInstructionButtonsContainer = css`
  margin-bottom: 14px;
`;

const deliveryInstructionButtonActiveStyle = css`
  background: #1f1e1e !important;
  color: #ffffff !important;
`;

const deliveryInstructionButtonStyle = css`
  font-weight: 400;
  font-size: 14px;
  line-height: 20.3px;
  border: 1px solid #e5e4e3;
  border-radius: 8px;
  color: #1f1e1e;
  background: #ffffff;
  margin-right: 8px;
  padding: 6px 12px;
  cursor: pointer;
`;

const infoContainerStyle = css`
  font-size: 12px;
  line-height: 17.4px;
  margin-bottom: 14px;
`;

const infoStyle = css`
  display: flex;

  & > :first-child {
    margin-right: 4px;
  }
`;

const deliveryInstructionTextContainer = css`
  margin-bottom: 24px;
  @media (max-width: 641px) {
    margin-bottom: 0;
  }
`;

const deliveryInstructionTextStyle = css`
  display: flex;
  flex-direction: column;
  height: 107px;
  border: 1px solid #6e6e6d;
  border-radius: 8px;
  padding: 8px;

  & .deliveryInstructionsTextAreaStyle {
    border: none;
    outline: none;
    resize: none;
  }

  & .deliveryInstructionsTextAreaStyle:focus {
    border: none;
    outline: none;
  }

  @media (max-width: 641px) {
    height: 88px;
  }
`;

const deliveryInstructionTextCounter = css`
  display: flex;
  padding: 0.5rem 1rem 0.5rem 0.5rem;
  font-size: 0.75rem;
  justify-content: flex-end;
`;

const deliveryInstructionBottomButtonContainer = css`
  display: flex;
  // flex: end; //TODO Need to fix this
  justify-content: center;
  @media (max-width: 641px) {
    // flex-direction: column-reverse;
    margin-left: auto;
    margin-right: auto;
    margin-top: 1.25rem;
  }
`;

const saveButtonStyle = css`
  width: 218px;
  margin: 0 0.375rem;
  min-width: 6rem;
  min-height: 3rem;
  border-radius: 6.25rem;
  background: #7b1a27;
  border: 0.063rem solid #7b1a27;
  color: #ffffff;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.45rem;
  text-align: center;
  cursor: pointer;
  @media (max-width: 641px) {
    width: 328px;
    margin: 0;
  }
`;

const cancelButtonStyle = css`
  background: #ffffff; !important;
  color: #7b1a27; !important;
  border: 0.063rem solid #7b1a27; !important;
`;

const infoIconWhiteStyle = css`
  display: flex;
  background: #ffffff;
  border: none;
`;

const infoIconWhiteContainer = css`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin: 0 0.3125rem;
    width: 24rem;
    svg {
        margin-bottom: 1rem;
    }

    p {
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.45rem;
    }

    button {
        width: 20.9375rem;
        height: 3rem;
        border: none;
        border-radius: 6.25rem;
        background: #7b1a27;
        color: #ffffff;
        padding: 0.75rem 1.25rem;
        margin-top: 1.5rem;
        font-size: 1rem;
        font-weight: 500;
        cursor: pointer;
    }
   @media (max-width: 641px) {
    width: auto;
  }
}
`;

interface IFormInput {
  deliveryInstruction: string;
}

const deliveryIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.5 4C2.22386 4 2 4.22386 2 4.5C2 4.77614 2.22386 5 2.5 5H14.0151C14.6929 5 15.2424 5.54949 15.2424 6.22731L15.2423 6.9058L15.2422 6.91833L15.2423 6.93084L15.2422 10.488C15.2422 11.0821 15.7238 11.5637 16.318 11.5637H20.9242C20.9392 11.5637 20.9532 11.5681 20.965 11.5756L20.9742 11.5825C20.99 11.5964 21 11.6167 21 11.6394L20.9998 15.4391C20.9998 16.1171 20.4502 16.6667 19.7723 16.6667H19.2861C19.0036 15.3504 17.8335 14.3636 16.4328 14.3636C15.0256 14.3636 13.8509 15.3598 13.5756 16.6854C13.5323 16.6732 13.4866 16.6666 13.4394 16.6666H10.0741C9.79169 15.3504 8.62153 14.3636 7.22092 14.3636C5.81362 14.3636 4.63899 15.3598 4.36372 16.6855C4.32035 16.6732 4.27458 16.6666 4.22727 16.6666H2.5C2.22386 16.6666 2 16.8905 2 17.1666C2 17.4428 2.22386 17.6666 2.5 17.6666H4.22727C4.26128 17.6666 4.2945 17.6632 4.3266 17.6568C4.5106 19.0913 5.73629 20.2 7.22092 20.2C8.70214 20.2 9.92561 19.0964 10.114 17.6666H13.4394C13.4733 17.6666 13.5065 17.6632 13.5385 17.6568C13.7225 19.0914 14.9482 20.2 16.4328 20.2C17.914 20.2 19.1375 19.0964 19.3259 17.6667H19.7723C21.0026 17.6667 21.9998 16.6693 21.9998 15.439L22 11.6394C22 11.3181 21.8591 11.0297 21.6358 10.8327L18.7367 6.85996C18.5342 6.58243 18.2113 6.41833 17.8678 6.41833H16.2424L16.2424 6.22735C16.2424 4.99723 15.2452 4 14.0151 4H2.5ZM16.2423 7.41833L16.2422 10.488C16.2422 10.5298 16.2761 10.5637 16.318 10.5637H20.2016L17.929 7.44943C17.9147 7.42989 17.892 7.41833 17.8678 7.41833H16.2423ZM16.4328 15.3636C15.3734 15.3636 14.5146 16.2224 14.5146 17.2818C14.5146 18.3412 15.3734 19.2 16.4328 19.2C17.4922 19.2 18.351 18.3412 18.351 17.2818C18.351 16.2224 17.4922 15.3636 16.4328 15.3636ZM7.22092 15.3636C6.16153 15.3636 5.30273 16.2224 5.30273 17.2818C5.30273 18.3412 6.16153 19.2 7.22092 19.2C8.2803 19.2 9.1391 18.3412 9.1391 17.2818C9.1391 16.2224 8.2803 15.3636 7.22092 15.3636Z"
      fill="#2A2928"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 11.9849C2 11.7087 2.22386 11.4849 2.5 11.4849H5.72379C5.99994 11.4849 6.22379 11.7087 6.22379 11.9849C6.22379 12.261 5.99994 12.4849 5.72379 12.4849H2.5C2.22386 12.4849 2 12.261 2 11.9849Z"
      fill="#2A2928"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 8.53027C2 8.25413 2.22386 8.03027 2.5 8.03027H11.5965C11.8727 8.03027 12.0965 8.25413 12.0965 8.53027C12.0965 8.80642 11.8727 9.03027 11.5965 9.03027H2.5C2.22386 9.03027 2 8.80642 2 8.53027Z"
      fill="#2A2928"
    />
  </svg>
);

const pickupIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.94271 4.87596C5.00526 4.37553 5.43066 4 5.93498 4H18.0522C18.5565 4 18.9819 4.37554 19.0445 4.87597L20.7087 18.1899C20.8952 19.682 19.7318 21 18.228 21H5.75916C4.25541 21 3.09195 19.682 3.27846 18.1899L4.94271 4.87596ZM18.0522 5L5.93498 5L4.27074 18.3139C4.15883 19.2092 4.85691 20 5.75916 20H18.228C19.1303 20 19.8284 19.2092 19.7164 18.3139L18.0522 5Z"
      fill="#2A2928"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.26623 8.01233L9.26559 8.01791L9.26269 8.04596C9.26017 8.07194 9.2567 8.11201 9.2534 8.16416C9.2468 8.26863 9.24098 8.42044 9.24484 8.60353C9.25262 8.97302 9.29951 9.45333 9.44836 9.92433C9.59702 10.3947 9.83957 10.8321 10.2233 11.1517C10.6001 11.4655 11.1539 11.7 11.9936 11.7C12.8333 11.7 13.3871 11.4655 13.7639 11.1517C14.1476 10.8321 14.3902 10.3947 14.5389 9.92433C14.6877 9.45333 14.7346 8.97302 14.7424 8.60353C14.7462 8.42044 14.7404 8.26863 14.7338 8.16416C14.7305 8.11202 14.727 8.07194 14.7245 8.04596L14.7216 8.01791L14.721 8.01271C14.6869 7.73906 14.8807 7.48855 15.1544 7.45395C15.4283 7.41932 15.6785 7.61333 15.7131 7.88729L15.2171 7.95C15.7131 7.88729 15.7131 7.88705 15.7131 7.88729L15.7133 7.88833L15.7134 7.88977L15.7139 7.89381L15.7154 7.90647C15.7166 7.91692 15.7181 7.93135 15.7199 7.9495C15.7234 7.98578 15.7278 8.03701 15.7318 8.10108C15.7399 8.22903 15.7467 8.40924 15.7421 8.62459C15.7331 9.05198 15.6793 9.63417 15.4924 10.2257C15.3053 10.8178 14.977 11.4429 14.4038 11.9202C13.8236 12.4033 13.0343 12.7 11.9936 12.7C10.9529 12.7 10.1636 12.4033 9.58344 11.9202C9.01023 11.4429 8.68196 10.8178 8.49484 10.2257C8.30791 9.63417 8.25407 9.05198 8.24506 8.62459C8.24053 8.40924 8.2473 8.22903 8.25539 8.10108C8.25944 8.03701 8.26384 7.98578 8.26735 7.9495C8.26911 7.93135 8.27065 7.91692 8.27182 7.90647L8.27329 7.89381L8.27378 7.88977L8.27395 7.88833C8.27398 7.88809 8.27408 7.88729 8.77014 7.95L8.27408 7.88729C8.30871 7.61333 8.55888 7.41932 8.83284 7.45395C9.10668 7.48856 9.30064 7.73852 9.26623 8.01233Z"
      fill="#2A2928"
    />
  </svg>
);

const blueInfoIcon = (
  <svg
    className="blueInfoIcon"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.25 8C0.25 3.71979 3.71979 0.25 8 0.25C12.2802 0.25 15.75 3.71979 15.75 8C15.75 12.2802 12.2802 15.75 8 15.75C3.71979 15.75 0.25 12.2802 0.25 8ZM8.67949 4.59999C8.67949 4.22472 8.37527 3.9205 8 3.9205C7.62473 3.9205 7.32051 4.22472 7.32051 4.59999V5.13332C7.32051 5.50859 7.62473 5.81281 8 5.81281C8.37527 5.81281 8.67949 5.50859 8.67949 5.13332V4.59999ZM8.67949 7.43349C8.67949 7.05821 8.37527 6.754 8 6.754C7.62473 6.754 7.32051 7.05821 7.32051 7.43349V11.4C7.32051 11.7753 7.62473 12.0795 8 12.0795C8.37527 12.0795 8.67949 11.7753 8.67949 11.4V7.43349Z"
      fill="#2D5A7A"
    />
  </svg>
);

const infoIcon = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_6413_24552)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.25 8C0.25 3.71979 3.71979 0.25 8 0.25C12.2802 0.25 15.75 3.71979 15.75 8C15.75 12.2802 12.2802 15.75 8 15.75C3.71979 15.75 0.25 12.2802 0.25 8ZM8.67949 4.59999C8.67949 4.22472 8.37527 3.9205 8 3.9205C7.62473 3.9205 7.32051 4.22472 7.32051 4.59999V5.13332C7.32051 5.50859 7.62473 5.81281 8 5.81281C8.37527 5.81281 8.67949 5.50859 8.67949 5.13332V4.59999ZM8.67949 7.43349C8.67949 7.05821 8.37527 6.754 8 6.754C7.62473 6.754 7.32051 7.05821 7.32051 7.43349V11.4C7.32051 11.7753 7.62473 12.0795 8 12.0795C8.37527 12.0795 8.67949 11.7753 8.67949 11.4V7.43349Z"
        fill="#2D5A7A"
      />
    </g>
    <defs>
      <clipPath id="clip0_6413_24552">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const infoModalIcon = (
  <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.8091 4.79158C17.894 1.18047 23.1062 1.18047 25.1911 4.79159L38.9031 28.5416C40.988 32.1527 38.3819 36.6666 34.2122 36.6666H6.78803C2.61828 36.6666 0.0121821 32.1527 2.09706 28.5416L15.8091 4.79158ZM23.026 6.04159C21.9034 4.09714 19.0968 4.09714 17.9742 6.04159L4.26212 29.7916C3.1395 31.736 4.54278 34.1666 6.78803 34.1666H34.2122C36.4574 34.1666 37.8607 31.736 36.7381 29.7916L23.026 6.04159ZM20.5001 11.25C21.1905 11.25 21.7501 11.8096 21.7501 12.5V22.4999C21.7501 23.1903 21.1905 23.7499 20.5001 23.7499C19.8097 23.7499 19.2501 23.1903 19.2501 22.4999V12.5C19.2501 11.8096 19.8097 11.25 20.5001 11.25ZM20.5001 26.0833C21.1905 26.0833 21.7501 26.6429 21.7501 27.3333V28.6666C21.7501 29.3569 21.1905 29.9166 20.5001 29.9166C19.8097 29.9166 19.2501 29.3569 19.2501 28.6666V27.3333C19.2501 26.6429 19.8097 26.0833 20.5001 26.0833Z"
      fill="#1F1E1E"
    />
  </svg>
);

const InfoIconWhite = ({ titleText = '', infoTextArray, modalType, analyticsEvents }) => {
  const [showInfo, setShowInfo] = useState(false);
  return (
    <div>
      <button className={infoIconWhiteStyle} onClick={() => { setShowInfo(true); if (modalType === 'DriverTip') {analyticsEvents('driver-tip-info')}}}>
        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_5865_46593)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8 2.25C4.54822 2.25 1.75 5.04822 1.75 8.5C1.75 11.9518 4.54822 14.75 8 14.75C11.4518 14.75 14.25 11.9518 14.25 8.5C14.25 5.04822 11.4518 2.25 8 2.25ZM0.25 8.5C0.25 4.21979 3.71979 0.75 8 0.75C12.2802 0.75 15.75 4.21979 15.75 8.5C15.75 12.7802 12.2802 16.25 8 16.25C3.71979 16.25 0.25 12.7802 0.25 8.5Z"
              fill="#1F1E1E"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8 4.42051C8.37527 4.42051 8.67949 4.72473 8.67949 5.1V5.63333C8.67949 6.0086 8.37527 6.31282 8 6.31282C7.62473 6.31282 7.32051 6.0086 7.32051 5.63333V5.1C7.32051 4.72473 7.62473 4.42051 8 4.42051ZM8 7.25401C8.37527 7.25401 8.67949 7.55823 8.67949 7.9335V11.9C8.67949 12.2753 8.37527 12.5795 8 12.5795C7.62473 12.5795 7.32051 12.2753 7.32051 11.9V7.9335C7.32051 7.55823 7.62473 7.25401 8 7.25401Z"
              fill="#1F1E1E"
            />
          </g>
          <defs>
            <clipPath id="clip0_5865_46593">
              <rect width="16" height="16" fill="white" transform="translate(0 0.5)" />
            </clipPath>
          </defs>
        </svg>
      </button>
      <Modal
        titleText={titleText}
        titleTextCenter={true}
        show={showInfo}
        fillScreen={true}
        halfHeightMobileModalPerc={'45'}
        showBottomTransitionModal={true}
        showStrokeLines={false}
        isDriverTipInfoModal={true}
        onClose={() => setShowInfo(false)}
      >
        <div className={infoIconWhiteContainer}>
          {modalType == 'DeliveyInstruction' && infoModalIcon}
          {infoTextArray.map((infoText, index) => (
            <p key={index}>{infoText}</p>
          ))}
          <button
            onClick={() => {
              setShowInfo(false);
            }}
            type="button"
          >
            Close
          </button>
        </div>
      </Modal>
    </div>
  );
};

const titleSpinnerStyle = css`
  margin-left: 0.5rem;
`;

export const renderSelectedTip = (selectedTip: any, appLabels: any, driverTipInfoStyle: string) => {
  const tipPercentage = get(selectedTip, 'tipPercentage', '');
  const tipAmount = get(selectedTip, 'tipAmount', null);

  // We return a function from _.cond, then immediately invoke it with ()
  return cond([
    // 1. If NOT "Other" and NOT "noTip", show standard numeric tip
    [
      () => tipPercentage !== DriverTipType.PREFERENCES_OTHER && tipPercentage !== DriverTipType.NOTIP,
      () => (
        <p>
          {formatString(get(appLabels, 'PreferenceTab.selectedTipAmountText', ''), {
            selectedTipAmount: tipPercentage,
          })}
        </p>
      ),
    ],
    // 2. If "noTip"
    [
      () => tipPercentage === DriverTipType.NOTIP && tipAmount === 0,
      () => <p>{get(appLabels, 'PreferenceTab.selectedNoTipText', '')}</p>,
    ],
    // 3. If "Other" AND tipAmount > 0
    [
      () => tipPercentage === DriverTipType.PREFERENCES_OTHER,
      () => <p>{`$${formatPrice(tipAmount)}${get(appLabels, 'PreferenceTab.selectedCustomTipAmountText', '')}`}</p>, // TODO: need to check with backed for decimal place
    ],
    // 4. Default case: "Other" with no tipAmount => no tip
    [
      () => true, // always returns true if above conditions fail
      () => <p className={driverTipInfoStyle}>{get(appLabels, 'PreferenceTab.setYourTipAmountText', '')}</p>,
    ],
  ])();
};

const PaymentErrorMessageComponent = () => {
  return (
    <div className={paymentErrorMessageContainereStyle}>
      <ErrorIcon />
      <div className={paymentErrorMessagTextStyle}>{appLabels.PreferenceTab.paymentErrorMessageText}</div>
    </div>
  );
};

const PaymentErrorIcon = () => (
  <div>
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_5912_4845)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0.25 8.5C0.25 4.21979 3.71979 0.75 8 0.75C12.2802 0.75 15.75 4.21979 15.75 8.5C15.75 12.7802 12.2802 16.25 8 16.25C3.71979 16.25 0.25 12.7802 0.25 8.5ZM4.75 7.5C4.19772 7.5 3.75 7.94772 3.75 8.5C3.75 9.05229 4.19772 9.5 4.75 9.5H11.25C11.8023 9.5 12.25 9.05229 12.25 8.5C12.25 7.94772 11.8023 7.5 11.25 7.5H4.75Z"
          fill="#B00000"
        />
      </g>
      <defs>
        <clipPath id="clip0_5912_4845">
          <rect width="16" height="16" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  </div>
);

const PreferencesComponent = ({ preferences, upcomingOrders, onSubmitForm }) => {
  // context variables
  const { appData, showToast } = useApp();
  const currentSessionContext = useContext(SessionContext) as SessionContextType;
  const preferenceContext = useContext(PreferencesContext) as PreferencesContextType;
  const user = get(currentSessionContext, 'user');

  //component local state variables
  const [showFulfillmentModal, setShowFulfillmentModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [preferencesError, setPreferencesError] = useState(false);
  const [showPaymentWidget, setShowPaymentWidget] = useState(false);
  const [showSlotsModal, setShowSlotsModal] = useState(false);
  const [showDriverTipModal, setShowDriverTipModal] = useState(false);
  const [updatingCardInfo, setUpdatingCardInfo] = useState(false);
  const [isMobileScreenSize, setIsMobileScreenSize] = useState(isMobileScreen());
  const [showDeliveryInstructionModal, setShowDeliveryInstructionModal] = useState(false);
  const isDeliveryType = get(preferences, 'fulfillmentTypes[0].value', '').toUpperCase() !== 'DUG';
  const storeData = get(preferences, 'stores[0]', {});
  const preferredAddress = isDeliveryType ? get(preferences, 'addresses[0]', {}) : get(storeData, 'address', {});
  const deliveryInstructionNotes = get(preferences, 'addresses[0].notes', []);
  const deliveryInstruction = get(find(deliveryInstructionNotes, { type: 'DELIVERY_INSTRUCTIONS' }), 'value', '');
  const deliveryInstructionNoteType = get(find(deliveryInstructionNotes, { type: 'DELIVERY_TYPE' }), 'value', '');
  const fulfillmentDay = get(preferences, 'slotPreference[0].fulfillmentDay', '');
  const fulfillmentStart = get(preferences, 'slotPreference[0].slotStartTS', '');
  const fulfillmentEnd = get(preferences, 'slotPreference[0].slotEndTS', '');
  const address2 = get(preferredAddress, 'address2', '');
  const fullAddress1 = `${get(preferredAddress, 'address1')}${address2 ? ' ' + address2 : ''}`;
  const fullAddress2 = `${get(preferredAddress, 'city')}, ${get(preferredAddress, 'state')}, ${get(preferredAddress, 'zipCode')}`;
  const maskedPaymentCard = get(preferences, 'payments[0].maskedNumber', '');
  const deliveryTimePreferences = `${fulfillmentDay} ${fulfillmentStart} - ${fulfillmentEnd}`;
  const userPayment = get(preferences, 'payments[0]', []);
  const tenderCardType = get(preferences, 'payments[0].cardType', '');
  const paymentFailure = get(upcomingOrders, 'preCheckFailReason') === 'PAYMENT_FAILURE';
  const customerType = appData.isBusinessBanner ? 'B' : '';

  const driverTipInfo = get(preferences, 'driverTipInfo', {});
  const driverTipOptions = get(driverTipInfo, 'driverTipOptions', []);
  const selectedTip = find(driverTipOptions, { tipSelected: true });
  const selectedTipValue = get(selectedTip, 'tipPercentage', '');
  const [driverTipOptionSelected, setDriverTipOptionSelected] = useState(selectedTipValue);
  const [isCustomTipValid, setIsCustomTipValid] = useState<boolean>(true);
  //user shop store id based on customer type (B2B or B2C)
  const selectedStoreId = customerType === 'B' ? get(user, 'storeId', '') : get(user, 'shopStoreId', '');

  const tipOptionsList = filter(driverTipOptions, (driverTipOption) => {
    const tipPercentage = get(driverTipOption, 'tipPercentage', '');
    const numericTipPercentage = ['5', '10', '15'];
    const isNumericTip = numericTipPercentage.includes(tipPercentage);
    const isNoTip = tipPercentage === DriverTipType.NOTIP;
    return isNumericTip || isNoTip;
  });

  const customOptionsList = filter(driverTipOptions, (driverTipOption) => {
    return get(driverTipOption, 'tipPercentage', '') === DriverTipType.PREFERENCES_OTHER;
  });

  const [isCustomTipSelected, setIsCustomTipSelected] = useState(get(customOptionsList[0], 'tipSelected', false));
  const [driverCustomTipValue, setDriverCustomTipValue] = useState(get(customOptionsList[0], 'tipAmount', ''));

  useEffect(() => {
    setDriverTipOptionSelected(selectedTipValue);
    if (driverTipOptionSelected === DriverTipType.PREFERENCES_OTHER) {
      setIsCustomTipSelected(true);
      setDriverCustomTipValue(get(selectedTip, 'tipAmount', ''));
    }
  }, [selectedTipValue, driverTipOptions]);

  useEffect(() => {
    if (driverTipOptionSelected === DriverTipType.PREFERENCES_OTHER) {
      setIsCustomTipSelected(true);
      if (!driverCustomTipValue) {
        setDriverCustomTipValue(get(selectedTip, 'tipAmount', ''));
      }
    } else {
      setIsCustomTipSelected(false);
      setDriverCustomTipValue('');
    }
  }, [driverTipOptionSelected]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileScreenSize(isMobileScreen());
    };

    window.addEventListener('resize', handleResize);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const getPreferences = async (): Promise<void> => {
    try {
      setIsLoading(true);
      await invoke(preferenceContext, 'fetchPreferences');
      setIsLoading(false);
    } catch (error) {
      setPreferencesError(true);
    }
  };

  const analyticsEvents = (caller: any, payload?: any) => {
    try {
      if (window['AB']?.DATALAYER) {
        switch (caller) {
          case 'slotPreference':
            window['AB'].DATALAYER.setModalViewEvents('ar:change-date-time|view');
            if (window?.['digitalData']) {
              window['digitalData'].pageFlags.isChangeDateTime = true;
            }
            break;
          case 'selectFulfillment':
            window['AB'].DATALAYER.setModalViewEvents('ar:fulfillment-edit|view');
            if (window?.['digitalData']) {
              window['digitalData'].pageFlags.isChangeDateTime = false;
            }
            break;
          case 'payment':
            window['AB'].DATALAYER.setLinkClickEvents('ar:subscribe-schedule-and-save|edit-payment');
            break;
          case 'deliveryPrefView':
            window['AB'].DATALAYER.setModalViewEvents('ar:fulfillment-delivery-instructions|view');
            break;
          case 'deliveryPrefClose':
            window['AB'].DATALAYER.setModalClickEvents('ar:fulfillment-delivery-instructions|cancel');
            break;
          case 'deliveryPrefSave':
            const modalMessage = `${payload?.deliveryInstructionType === DeliveryInstructionType.UNATTENDED 
              ? 'leave-at-the-door' : payload?.deliveryInstructionType === DeliveryInstructionType.ATTENDED 
              ? 'hand-it-to-me' : 'delivery-pref-missing'}|${payload?.deliveryInstruction ? 'yes' : 'no'}`;
            window['AB'].DATALAYER.setModalClickEvents('ar:fulfillment-delivery-instructions|save', modalMessage);
            break;
          case 'edit-tip':
            window['AB'].DATALAYER.setModalViewEvents('edit-your-tip-prf|view', true);
            break;
          case 'save-tip':
            window['AB'].DATALAYER.setModalClickEvents(`edit-your-tip-prf|${payload}:save`);
            break;
          case 'edit-tip-close':
            window['AB'].DATALAYER.setModalClickEvents('edit-your-tip-prf|close');
            break;
          case 'driver-tip-info':
            window['AB'].DATALAYER.setModalViewEvents('driver-tip-info|view', true);
            break;
          default:
            break;
        }
      }
    } catch (error) {
      // Handle any errors that occur during execution
      console.error('@AnalyticsTeam error:', error);
    }
  };

  const saveDeliveryPreferences = async (data) => {
    setIsLoading(true);
    setShowDeliveryInstructionModal(false);

    try {
      const requestPayload = {
        address: {
          addressId: get(preferredAddress, 'addressId', ''),
          notes: [
            {
              type: 'DELIVERY_INSTRUCTIONS',
              value: data.deliveryInstruction,
            },
            {
              type: 'DELIVERY_TYPE',
              value: data.deliveryInstructionType,
            },
          ],
        },
      };
      const deliveryPreference = await invoke(currentSessionContext, 'ensureActiveSession', () =>
        updateDeliveryInstructionsService(appData.environmentVariables, user, requestPayload),
      );

      if (
        (get(deliveryPreference, 'data') && get(deliveryPreference.data, 'type') !== 'SUCCESS') ||
        get(deliveryPreference.data, 'statusCode') !== 200
      ) {
        throw new Error(get(deliveryPreference, 'message', ''));
      }

      showToast('info', 'Delivery instructions saved.');

      await invoke(preferenceContext, 'fetchPreferences');
      setIsLoading(false);
    } catch (error) {
      showToast(
        'error',
        'Oops! We can’t save changes to your delivery instructions right now. Please try again later.',
      );
      setIsLoading(false);
    }
  };

  const getSuccessMessage = (appLabels, tipPercentage, isCustomTipSelected, tipAmount = 0) => {
    const noTipMsg = get(appLabels, 'PendingOrderContent.updateNoTipSuccessForAllOrdersResponse', '');
    const customTipMsg = get(appLabels, 'PendingOrderContent.updateCustomTipSuccessForAllOrdersResponse', '');
    const standardTipMsg = get(appLabels, 'PendingOrderContent.updateTipSuccessForAllOrdersResponse', '');

    if (tipPercentage === 'noTip' || (tipPercentage === DriverTipType.PREFERENCES_OTHER && tipAmount === 0.0)) {
      return formatString(noTipMsg, { tipPercentage: 'No tip' });
    }
    if (isCustomTipSelected) {
      return formatString(customTipMsg, { tipPercentage: tipAmount });
    }
    return formatString(standardTipMsg, { tipPercentage });
  };

  const saveDriverTipPreference = async () => {
    setIsLoading(true);
    setShowDriverTipModal(false);

    const payload = {
      tipPercentage: isCustomTipSelected ? DriverTipType.PREFERENCES_OTHER : driverTipOptionSelected,
      preferences: true,
      ...(isCustomTipSelected && { tipAmount: driverCustomTipValue }),
      ...(!isCustomTipSelected && driverTipOptionSelected === DriverTipType.NOTIP && { tipAmount: 0 }),
    };

    const tipPercentage = get(payload, 'tipPercentage', '');
    const tipAmount = get(payload, 'tipAmount', '');

    try {
      // Ensure session is active, then update driver tip
      const response = await invoke(currentSessionContext, 'ensureActiveSession', () =>
        updateDriverTipService(appData.environmentVariables, user, payload),
      );

      // If response is invalid or not SUCCESS, throw error
      if (get(response, 'data.type') !== 'SUCCESS' || get(response, 'data.statusCode') !== 200) {
        throw new Error(get(response, 'message', 'Failed to update tip.'));
      }

      // Show success toast
      analyticsEvents('save-tip', isCustomTipSelected ? 'custom-tip' : driverTipOptionSelected === DriverTipType.NOTIP ? 'no-tip' : tipPercentage);
      const successMessage = getSuccessMessage(appLabels, tipPercentage, isCustomTipSelected, tipAmount);
      showToast('info', successMessage);

      // Fetch updated preferences
      await invoke(preferenceContext, 'fetchPreferences');
      await invoke(preferenceContext, 'fetchUpcomingOrders');
    } catch (error) {
      showToast('error', appLabels.PendingOrderContent.updateTipErrorMessage);
      setShowDriverTipModal(false);
    } finally {
      setIsLoading(false);
    }
  };
  const handleDriverTipModalClose = () => {
    analyticsEvents('edit-tip-close');
    setShowDriverTipModal(false);
    setDriverTipOptionSelected(selectedTipValue);
  };

  useEffect(() => {
    if (user && user.authToken) {
      getPreferences();
    }
  }, [user]);

  const paymentRedirect = async (routeToScheduleSave, tenderUpdated) => {
    if (routeToScheduleSave) {
      if (tenderUpdated) {
        showToast('info', appLabels.PreferenceTab.paymentSuccessMessage);

        setUpdatingCardInfo(true);
        await updateCardStatus(appData.environmentVariables, user);
        // wait for the info to be updated and only then hide the spinner and trigger an upcoming order fetch
        setUpdatingCardInfo(false);
        await invoke(preferenceContext, 'fetchUpcomingOrders');
        setShowPaymentWidget(false);
      } else {
        setShowPaymentWidget(false);
      }
      await getPreferences();
    }
  };

  const DeliveryInstructionsModal = ({
    setShowDeliveryInstructionModal,
    deliveryInstructionType,
    setDeliveryInstructionType,
    deliveryInstruction,
    onSave,
  }) => {
    const [textBoxCharCount, setTextBoxCharCount] = useState(0);
    const handleDeliveryInstructionType = (value: string) => {
      setDeliveryInstructionType(value);
    };

    const { register, handleSubmit, watch, reset, setValue } = useForm<IFormInput>({
      mode: 'onChange',
      defaultValues: {
        deliveryInstruction: deliveryInstruction,
      },
    });

    useEffect(() => {
      setTextBoxCharCount(get(deliveryInstruction, 'length', 0));
    }, [deliveryInstruction]);

    const handleTextChange = (e) => {
      const count = e.target.value.length;
      if (count <= DELIVERY_NOTES_CHAR_COUNT) {
        setTextBoxCharCount(count);
        setValue('deliveryInstruction', e.target.value);
      }
    };

    const submitFormData = async (data) => {
      const currentData: IFormInput = watch();
      reset(currentData, { keepValues: true });
      const payload = {
        deliveryInstructionType,
        deliveryInstruction: currentData.deliveryInstruction,
      };
      analyticsEvents('deliveryPrefSave', payload);
      onSave(payload);
    };

    return (
      <div className={deliveryInstructionModal}>
        <div className={deliveryInstructionButtonsContainer}>
          <button
            className={`${deliveryInstructionButtonStyle} ${deliveryInstructionType === DeliveryInstructionType.UNATTENDED ? deliveryInstructionButtonActiveStyle : ''}`}
            onClick={() => handleDeliveryInstructionType(DeliveryInstructionType.UNATTENDED)}
          >
            {appLabels.PreferenceTab.leaveAtDoorText}
          </button>
          <button
            className={`${deliveryInstructionButtonStyle} ${deliveryInstructionType === DeliveryInstructionType.ATTENDED ? deliveryInstructionButtonActiveStyle : ''}`}
            onClick={() => handleDeliveryInstructionType(DeliveryInstructionType.ATTENDED)}
          >
            {appLabels.PreferenceTab.handItToMeText}
          </button>
        </div>
        {deliveryInstructionType === DeliveryInstructionType.ATTENDED ? (
          ''
        ) : (
          <div className={infoContainerStyle}>
            <div className={infoStyle}>
              <div>{infoIcon}</div>
              <div>{appLabels.PreferenceTab.leaveAtDoorInfo}</div>
            </div>
          </div>
        )}
        <form onSubmit={handleSubmit(submitFormData)} data-testid="instruction-form">
          <div className={deliveryInstructionTextContainer}>
            <div className={deliveryInstructionTextStyle}>
              <span
                className={`${defaultDeliveryInstructiontStyle} ${textBoxCharCount ? deliveryInstructionActiveStyle : ''}`}
              >
                {appLabels.PreferenceTab.defaultDeliveryInstruction}
              </span>
              <textarea
                className="deliveryInstructionsTextAreaStyle"
                data-testid="delivery-instruction-textarea"
                {...register('deliveryInstruction')}
                onChange={(event) => {
                  handleTextChange(event);
                }}
                value={watch('deliveryInstruction')}
              />
            </div>
            <div className={deliveryInstructionTextCounter}>{textBoxCharCount}/250</div>
          </div>
          <div className={deliveryInstructionBottomButtonContainer}>
            {isMobile() || isMobileScreenSize ? (
              ''
            ) : (
              <button
                className={`${saveButtonStyle} ${cancelButtonStyle}`}
                onClick={() => {
                  analyticsEvents('deliveryPrefClose');
                  setShowDeliveryInstructionModal(false);
                }}
              >
                {appLabels.PreferenceTab.cancel}
              </button>
            )}
            <button type="submit" className={saveButtonStyle}>
              {appLabels.PreferenceTab.save}
            </button>
          </div>
        </form>
      </div>
    );
  };

  const DeliveryInstructionComponent = ({
    deliveryInstructionNoteType,
    deliveryInstruction,
    saveDeliveryPreferences,
  }) => {
    const [deliveryInstructionType, setDeliveryInstructionType] = useState(deliveryInstructionNoteType);
    return (
      <div className={colStyle}>
        <div className={`${sectionStyle} ${sectionMobileStyle}`}>
          <div className={titleRowStyle}>
            <div>
              <div className={deliveryInstructionStyle}>
                <p className={deliveryInstructionTypeStyle}>
                  {deliveryInstructionType === DeliveryInstructionType.ATTENDED
                    ? appLabels.PreferenceTab.attended_deliveryInstructionTypeText
                    : appLabels.PreferenceTab.unAttended_deliveryInstructionTypeText}
                </p>
                {deliveryInstructionType != DeliveryInstructionType.ATTENDED && (
                  <InfoIconWhite
                    infoTextArray={appLabels.PreferenceTab.deliveryInstructionModalTextArray}
                    modalType={'DeliveyInstruction'}
                    analyticsEvents={analyticsEvents}
                  />
                )}
              </div>
              <p
                className={`${deliveryInstruction === '' ? defaultDeliveryInstructiontStyle : ''} ${deliveryInstructionMessage}`}
              >
                {deliveryInstruction || appLabels.PreferenceTab.defaultDeliveryInstruction}
              </p>
            </div>
            <div className={editButtonContainerStyle}>
              <EditButton
                className="link-xs"
                data-testid="edit-delivery-instructions-button"
                onClick={() => {
                  setShowDeliveryInstructionModal(true);
                  analyticsEvents('deliveryPrefView');
                }}
              >
                {appLabels.PreferenceTab.edit}
              </EditButton>
              <Modal
                titleText={appLabels.PreferenceTab.deliveryInstructionModalTilte}
                titleTextCenter={true}
                description=""
                onClose={() => {
                  analyticsEvents('deliveryPrefClose');
                  setShowDeliveryInstructionModal(false)
                }}
                show={showDeliveryInstructionModal}
                halfHeightMobileModalPerc={'50'}
                fillScreen={true}
                showBottomTransitionModal={true}
              >
                <DeliveryInstructionsModal
                  setShowDeliveryInstructionModal={setShowDeliveryInstructionModal}
                  deliveryInstructionType={deliveryInstructionType}
                  setDeliveryInstructionType={setDeliveryInstructionType}
                  deliveryInstruction={deliveryInstruction}
                  onSave={saveDeliveryPreferences}
                />
              </Modal>
            </div>
          </div>
        </div>
      </div>
    );
  };

  if (preferencesError)
    return (
      <UserMessage
        className={errorContainer}
        messageText={appLabels.PreferenceTab.apiErrorMessage}
        messageType={'warning'}
      />
    );

  return (
    <>
      {isLoading ? (
        <LoadingComponent />
      ) : (
        <div className={mainContainerStyle}>
          {paymentFailure && <PaymentErrorMessageComponent />}
          <div>
            {showPaymentWidget && (
              <PaymentWallet
                paymentMethodContext={paymentConfig.paymentContext}
                client={paymentConfig.client}
                scheduleSaveFlow={paymentConfig.paymentEdit}
                shopStoreId={selectedStoreId}
                routeToScheduleSave={paymentRedirect}
                paymentMethods={userPayment}
                shopToken={user.authToken}
                customerType={customerType}
              />
            )}
            {!showPaymentWidget ? (
              <div className={preferencesContainerStyle}>
                <div className={`${sectionStyle} ${sectionMobileStyle}`}>
                  <div className={titleRowStyle}>
                    <p className={`title-sm ${sectionTitleStyle}`}>{appLabels.PreferenceTab.fulfillmentMethod}</p>
                    <div className={editButtonContainerStyle}>
                      <EditButton
                        data-testid="edit-payments-button"
                        onClick={() => {
                          setShowFulfillmentModal(true);
                          analyticsEvents('selectFulfillment');
                        }}
                        className="link-xs"
                      >
                        {appLabels.PreferenceTab.edit}
                      </EditButton>
                      {showFulfillmentModal && (
                        <SelectFulfillmentMethod
                          preferredData={storeData}
                          onClose={() => setShowFulfillmentModal(false)}
                        />
                      )}
                    </div>
                  </div>
                  <div className={deliveryTypeStyle}>
                    <div className={IconStyle}>{isDeliveryType ? deliveryIcon : pickupIcon}</div>
                    <p className={`body-text ${textStyle}`}>
                      {isDeliveryType ? appLabels.PreferenceTab.delivery : appLabels.PreferenceTab.pickup}:
                    </p>
                  </div>
                  <p className={`body-text ${fullAddressOneSpace}`}>{fullAddress1},</p>
                  <p className={`body-text ${textStyle}`}>{fullAddress2}</p>
                </div>
                {isMobile() || isMobileScreenSize
                  ? isDeliveryType && (
                      <DeliveryInstructionComponent
                        deliveryInstructionNoteType={deliveryInstructionNoteType}
                        deliveryInstruction={deliveryInstruction}
                        saveDeliveryPreferences={saveDeliveryPreferences}
                      />
                    )
                  : ''}

                {isMobile() || isMobileScreenSize
                  ? isDeliveryType && (
                      <div className={`${sectionStyle} ${sectionMobileStyle}`}>
                        <div className={titleRowStyle}>
                          <div>
                            <div className={driverTipStyle}>
                              <p className={`body-text ${textStyle}`}>Driver tip (optional)</p>
                              <InfoIconWhite
                                titleText={appLabels.PreferenceTab.driverTipPreferenceModalTitleText}
                                infoTextArray={appLabels.PreferenceTab.driverTipPreferenceModalTextArray}
                                modalType={'DriverTip'}
                                analyticsEvents={analyticsEvents}
                              />
                            </div>
                            {renderSelectedTip(selectedTip, appLabels, driverTipInfoStyle)}
                          </div>
                          <div className={editButtonContainerStyle}>
                            <EditButton
                              onClick={() => {
                                setShowDriverTipModal(true);
                                analyticsEvents('edit-tip');
                              }}
                              className="link-xs"
                            >
                              {appLabels.PreferenceTab.edit}
                            </EditButton>
                            <Modal
                              titleText="Set Your Tip Preferences"
                              titleTextCenter={true}
                              show={showDriverTipModal}
                              fillScreen={true}
                              showBottomTransitionModal={true}
                              halfHeightMobileModalPerc={'75'}
                              modalOverflowValue="hidden"
                              overFlowBodyHidden={true}
                              isDriverTipInfoModal={true}
                              onClose={handleDriverTipModalClose}
                            >
                              <div className={infoIconWhiteContainer}>
                                <p className={driverTipOptionsInfo}>{appLabels.PreferenceTab.editDriverTipModalText}</p>
                                <div className={driverTipOptionsContainer}>
                                  <div className={driverTipOptionsStyle}>
                                    {map(tipOptionsList, ({ tipPercentage, tipSelected }, index) => (
                                      <TipOptions
                                        key={tipPercentage}
                                        isCustomTipSelected={isCustomTipSelected}
                                        setIsCustomTipSelected={setIsCustomTipSelected}
                                        index={index}
                                        tabType={'preferences'}
                                        tipSelected={tipSelected}
                                        tipPercentage={tipPercentage}
                                        setIsCustomTipValid={setIsCustomTipValid}
                                        driverTipOptionSelected={driverTipOptionSelected}
                                        setDriverTipOptionSelected={setDriverTipOptionSelected}
                                      />
                                    ))}
                                    <CustomTip
                                      isCustomTipSelected={isCustomTipSelected}
                                      setIsCustomTipSelected={setIsCustomTipSelected}
                                      className={customTipStyle}
                                      tabType={'preferences'}
                                      driverTipOptionSelected={driverTipOptionSelected}
                                      setDriverTipOptionSelected={setDriverTipOptionSelected}
                                      driverCustomTipValue={driverCustomTipValue}
                                      setDriverCustomTipValue={setDriverCustomTipValue}
                                      isCustomTipValid={isCustomTipValid}
                                      setIsCustomTipValid={setIsCustomTipValid}
                                    />
                                  </div>
                                </div>
                                {(driverTipOptionSelected == '5' ||
                                  driverTipOptionSelected == '10' ||
                                  driverTipOptionSelected == '15') && (
                                  <div className={editDriverTipStyle}>
                                    {blueInfoIcon}
                                    <p>{appLabels.PreferenceTab.editDriverTipModalInfoText}</p>
                                  </div>
                                )}
                                <button
                                  className={`${driverTipSaveButton}`}
                                  onClick={saveDriverTipPreference}
                                  type="button"
                                  //disabled={!isCustomTipValid && isCustomTipSelected}
                                >
                                  Save
                                </button>
                              </div>
                            </Modal>
                          </div>
                        </div>
                      </div>
                    )
                  : ''}
                <div className={colStyle}>
                  <div className={`${sectionStyle}`}>
                    <div className={titleRowStyle}>
                      <p className={`title-sm ${sectionTitleStyle}`}>{appLabels.PreferenceTab.dayAndTime}</p>
                      <div className={editButtonContainerStyle}>
                        <EditButton
                          data-testid="edit-date-time-button"
                          className="link-xs"
                          onClick={() => {
                            setShowSlotsModal(true);
                            analyticsEvents('slotPreference');
                          }}
                        >
                          {appLabels.PreferenceTab.edit}
                        </EditButton>
                        <Modal
                          titleText={appLabels.PreferenceTab.dayAndTime}
                          description=""
                          onClose={() => setShowSlotsModal(false)}
                          show={showSlotsModal}
                          fillScreen={true}
                        >
                          <SlotPreferences
                            onConfirm={() => setShowSlotsModal(false)}
                            pickup={get(preferences, 'fulfillmentTypes.0.value') === 'DUG'}
                            preselectedSlot={get(preferences, 'slotPreference.0')}
                          />
                        </Modal>
                      </div>
                    </div>
                    <p className={`body-text ${textStyle}`}>{deliveryTimePreferences}</p>
                  </div>
                </div>

                {isMobileScreenSize ? (
                  ''
                ) : (
                  <div>
                    {isDeliveryType && (
                      <DeliveryInstructionComponent
                        deliveryInstructionNoteType={deliveryInstructionNoteType}
                        deliveryInstruction={deliveryInstruction}
                        saveDeliveryPreferences={saveDeliveryPreferences}
                      />
                    )}
                  </div>
                )}
                <div className={`${sectionStyle}`}>
                  <div className={titleRowStyle}>
                    <p className={`title-sm ${sectionTitleStyle}`}>
                      {appLabels.PreferenceTab.paymentMethod}
                      {updatingCardInfo ? (
                        <Spinner className={titleSpinnerStyle} size={16} dotSize={2} dots={6} />
                      ) : null}
                    </p>
                    <div className={editButtonContainerStyle}>
                      <EditButton
                        data-testid="edit-payment-button"
                        onClick={() => {
                          setShowPaymentWidget(true);
                          analyticsEvents('payment');
                        }}
                        className="link-xs"
                      >
                        {appLabels.PreferenceTab.edit}
                      </EditButton>
                    </div>
                  </div>
                  {maskedPaymentCard ? (
                    <>
                      <span>
                        <img
                          className={tenderIcon}
                          src={`https://images.albertsons-media.com/is/image/ABS/sub_${tenderCardType.toLowerCase()}_icon?$ccicon$&defaultImage=Not_Available`}
                          alt="Credit Card Logo"
                        />
                        <span className={`body-text ${textStyle}`}>•••• {maskedPaymentCard}</span>
                      </span>
                    </>
                  ) : (
                    <p className={`body-text ${textStyle}`}>{appLabels.PreferenceTab.noPaymentMethod}</p>
                  )}
                  {paymentFailure && (
                    <div className={addPaymentTextContainerStyle}>
                      <PaymentErrorIcon />
                      <div className={addPaymentTextStyle}>{appLabels.PreferenceTab.addPaymentText}</div>
                    </div>
                  )}
                </div>

                {isMobile() || isMobileScreenSize
                  ? ''
                  : isDeliveryType && (
                      <div className={`${sectionStyle}`}>
                        <div className={titleRowStyle}>
                          <div>
                            <div className={driverTipStyle}>
                              <p className={`body-text ${textStyle}`}>Driver tip (optional)</p>
                              <InfoIconWhite
                                titleText={appLabels.PreferenceTab.driverTipPreferenceModalTitleText}
                                infoTextArray={appLabels.PreferenceTab.driverTipPreferenceModalTextArray}
                                modalType={'DriverTip'}
                                analyticsEvents={analyticsEvents}
                              />
                            </div>
                            {renderSelectedTip(selectedTip, appLabels, driverTipInfoStyle)}
                          </div>
                          <div className={editButtonContainerStyle}>
                            <EditButton
                              onClick={() => {
                                setShowDriverTipModal(true);
                                analyticsEvents('edit-tip');
                              }}
                              className="link-xs"
                              data-testid="edit-driver-tip-button"
                            >
                              {appLabels.PreferenceTab.edit}
                            </EditButton>
                            <Modal
                              titleText="Set Your Tip Preferences"
                              titleTextCenter={true}
                              show={showDriverTipModal}
                              fillScreen={true}
                              showBottomTransitionModal={true}
                              halfHeightMobileModalPerc={'50'}
                              modalOverflowValue="hidden"
                              overFlowBodyHidden={true}
                              onClose={handleDriverTipModalClose}
                            >
                              <div className={infoIconWhiteContainer}>
                                <p className={driverTipOptionsInfo}>{appLabels.PreferenceTab.editDriverTipModalText}</p>
                                <div className={driverTipOptionsContainer}>
                                  <div className={driverTipOptionsStyle}>
                                    {map(tipOptionsList, ({ tipPercentage, tipSelected }, index) => (
                                      <TipOptions
                                        key={tipPercentage}
                                        isCustomTipSelected={isCustomTipSelected}
                                        setIsCustomTipSelected={setIsCustomTipSelected}
                                        index={index}
                                        tabType={'preferences'}
                                        tipSelected={tipSelected}
                                        tipPercentage={tipPercentage}
                                        setIsCustomTipValid={setIsCustomTipValid}
                                        driverTipOptionSelected={driverTipOptionSelected}
                                        setDriverTipOptionSelected={setDriverTipOptionSelected}
                                      />
                                    ))}
                                    <CustomTip
                                      isCustomTipSelected={isCustomTipSelected}
                                      setIsCustomTipSelected={setIsCustomTipSelected}
                                      className={customTipStyle}
                                      tabType={'preferences'}
                                      driverTipOptionSelected={driverTipOptionSelected}
                                      setDriverTipOptionSelected={setDriverTipOptionSelected}
                                      driverCustomTipValue={driverCustomTipValue}
                                      setDriverCustomTipValue={setDriverCustomTipValue}
                                      isCustomTipValid={isCustomTipValid}
                                      setIsCustomTipValid={setIsCustomTipValid}
                                    />
                                  </div>
                                </div>
                                {(driverTipOptionSelected == '5' ||
                                  driverTipOptionSelected == '10' ||
                                  driverTipOptionSelected == '15') && (
                                  <div className={editDriverTipStyle}>
                                    {blueInfoIcon}
                                    <p>{appLabels.PreferenceTab.editDriverTipModalInfoText}</p>
                                  </div>
                                )}
                                <button
                                  className={`${driverTipSaveButton}`}
                                  onClick={saveDriverTipPreference}
                                  type="button"
                                >
                                  Save
                                </button>
                              </div>
                            </Modal>
                          </div>
                        </div>
                      </div>
                    )}
              </div>
            ) : null}
          </div>
        </div>
      )}
    </>
  );
};

PreferencesComponent.propTypes = {
  children: PropTypes.any,
  preferences: PropTypes.object.isRequired,
  upcomingOrders: PropTypes.object.isRequired,
  onSubmitForm: PropTypes.func,
};

export default PreferencesComponent;
